export const CookiesAuthName = 'Ristomatico'
export const AccessLevels = {
  Undefined: -1,
  Viewer: 0,
  Operator: 1,
  Admin: 2
}

export const colorsTemp = ['#0ede02']
